import { Link } from "react-router-dom";
import { FaArrowRight, FaUserGraduate } from "react-icons/fa";
import { getStudentDisplayName } from "../utils/studentUtils";

const StudentCard = ({ student }) => (
  <article className="student-card">
    <div className="student-avatar" aria-hidden="true">
      <FaUserGraduate />
    </div>
    <div className="student-card-body">
      <h2>{getStudentDisplayName(student)}</h2>
      <p>
        Grade {student.grade || "Not set"} • Age {student.age ?? "Not set"}
      </p>
      <span>{student.email || "No credential email"}</span>
    </div>
    <div className="student-card-actions">
      <Link to="/dashboard/reports" className="student-card-link secondary">
        <span>View Report</span>
      </Link>
      <Link to={`/dashboard/students/${student.id}`} className="student-card-link">
        <span>Details</span>
        <FaArrowRight aria-hidden="true" />
      </Link>
    </div>
  </article>
);

export default StudentCard;
